import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard }            from './auth-guard.service';
import { AuthService }          from './auth.service';

import { LoginComponent }       from './login/login.component';
import { SignComponent }       from './sign/sign.component';
import { ForgotComponent }       from './forgot/forgot.component';
import { RulesUnauthComponent }       from './../custom/rules-unauth/rules-unauth.component';
import { LocateUnauthComponent }       from './../custom/locate-unauth/locate-unauth.component';
import { CountryGuard } from './country-guard.service';


const authRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'sign',
    component: SignComponent
  },
  {
    path: 'forgot',
    component: ForgotComponent
  },
  {
    path: 'rules',
    component: RulesUnauthComponent
  },
  {
    path: 'locate',
    component: LocateUnauthComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(authRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AuthGuard,
    CountryGuard,
    AuthService
  ],
})
export class LoginRoutingModule {}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/auth/auth-routing.module.ts